(ns client-portal.client.products.views
  (:require [shared.core.amelia-light.components.components :as alc]
            [shared.core.reactive :as re]
            [shared.core.util :as util]))

(defn products-dropdown [_]
  (let [products- (re/subscribe [:products/list-])]
    (fn [{:keys [value only-reference-ids] :as args}]
      (let [products (util/when-not-loading @products-)]
        [alc/up-popover-button-dropdown
         (merge (dissoc args :value)
                {:placeholder "Product"
                 :options (some->> products
                                   (filter #(or (empty? only-reference-ids)
                                                (contains? only-reference-ids (:reference-id %))))
                                   (mapv (fn [{:keys [label reference-id]}]
                                           {:text label
                                            :value reference-id
                                            :selected? (= value reference-id)})))})]))))
